import {extend, pick} from 'lodash'

export const SET_FETCHING_VEHICLES = 'setFetchingVehicles'
export const SET_INVENTORY_VEHICLES = 'setInventoryVehicles'
export const UPDATE_INVENTORY_VEHICLE = 'updateInventoryVehicle'

export default {
    [SET_FETCHING_VEHICLES](state, loading) {
        state.loading = loading;
    },
    [SET_INVENTORY_VEHICLES]({inventoryVehicles}, {data, meta}) {
        inventoryVehicles.data = data;
        inventoryVehicles.meta = meta;
    },
    [UPDATE_INVENTORY_VEHICLE](state, {vehicle, newVehicle, fields}) {
        let newData = newVehicle;
        if (fields) {
            newData = pick(newVehicle, fields)
        }
        extend(vehicle, newData)
    },
}
